<template>
    <div id="notifications-template-form">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                {
                    text: 'Notifications Template',
                    to: { path: '/notifications-template' },
                },
                {
                    text: !$route.query.id
                        ? 'Tambah Notifikasi'
                        : 'Ubah Notifikasi',
                },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">
            {{ !$route.query.id ? "Tambah Notifikasi" : "Ubah Notifikasi" }}
        </h3>

        <div>
            <v-card flat class="d-flex">
                <v-col cols="3" class="py-0">
                    <v-card flat>
                        <v-card-text class="pa-0 my-2">
                            <v-card
                                flat
                                class="border-bottom-divider rounded-tl pa-0"
                            >
                                <a href="javascript:;">
                                    <img
                                        :src="
                                            form.img_url
                                                ? form.img_url
                                                : require('@/assets/img/unavailable.png')
                                        "
                                    />
                                </a>
                            </v-card>
                        </v-card-text>
                        <v-card-text class="pa-0 my-2">
                            <v-btn
                                @click="$refs.uploader.click()"
                                block
                                class="pa-0 font-weight-bold dark--text"
                                color="white"
                            >
                                Upload *
                            </v-btn>
                            <input
                                id="notification_image"
                                type="file"
                                ref="uploader"
                                class="d-none"
                                accept="image/*"
                                @change="onFileChange"
                            />
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Rasio thumbnail foto 16:9
                        </v-card-text>
                        <v-card-text
                            class="text-caption pa-0 d-flex justify-center"
                        >
                            Maximum size is 200 KB
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="9" style="border-left: 1px solid #f0f0f0">
                    <v-card flat>
                        <v-card-text class="pa-0">
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Title *
                                    </v-list-item-title>
                                    <v-text-field
                                        placeholder="Judul Notifikasi"
                                        v-model="form.title"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Body *
                                    </v-list-item-title>
                                    <v-textarea
                                        placeholder="Body Notifikasi"
                                        v-model="form.body"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="px-0 pt-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Feature *
                                    </v-list-item-title>

                                    <v-select
                                        outlined
                                        placeholder="Pilih Feature"
                                        v-model="form.feature"
                                        class="pa-0"
                                        :items="featureList"
                                        item-text="feature_name"
                                        item-value="id"
                                    ></v-select>
                                </v-list-item-content>
                            </v-list-item>
                            <template>
                                <v-btn
                                    depressed
                                    class="white--text blew"
                                    @click="openFormFeature()"
                                    ><v-icon small class="pr-2"
                                        >mdi-plus-circle</v-icon
                                    >
                                    Feature
                                </v-btn>
                            </template>
                            <v-list-item two-line class="pt-6 pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Webapp Link *
                                    </v-list-item-title>
                                    <v-text-field
                                        placeholder="Judul Tryout"
                                        v-model="form.webapp_link"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        Android Link *
                                    </v-list-item-title>
                                    <v-text-field
                                        placeholder="Judul Tryout"
                                        v-model="form.android_link"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item two-line class="pa-0">
                                <v-list-item-content class="pa-0">
                                    <v-list-item-title
                                        class="font-weight-bold pb-2"
                                    >
                                        iOs Link *
                                    </v-list-item-title>
                                    <v-text-field
                                        placeholder="Judul Tryout"
                                        v-model="form.ios_link"
                                        outlined
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </v-card-text>
                        <v-card-actions class="pa-4">
                            <v-spacer></v-spacer>
                            <v-btn
                                depressed
                                class="px-6 py-2 white--text"
                                color="blew"
                                @click="putObject()"
                                id="notifikasi_simpan"
                                >Simpan</v-btn
                            >
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-card>
        </div>

        <v-dialog
            v-model="featureModal"
            transition="dialog-top-transition"
            width="800px"
            height="200px"
            @click:outside="featureModal = false"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title class="d-flex" width="100%">
                        Tambah Feature
                        <v-spacer></v-spacer>
                        <v-btn icon small @click="dialog.value = false">
                            <v-icon>mdi-close-circle</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-text class="px-6" width="100%">
                        <v-list-item two line>
                            <v-list-item-content>
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Service
                                </v-list-item-title>

                                <v-select
                                    outlined
                                    placeholder="Pilih Service"
                                    v-model="featureForm.service_id"
                                    class="pa-0"
                                    :items="serviceList"
                                    item-text="service_name"
                                    item-value="id"
                                ></v-select>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content class="pa-0">
                                <v-list-item-title
                                    class="font-weight-bold pb-2"
                                >
                                    Feature Name *
                                </v-list-item-title>
                                <v-text-field
                                    v-model="featureForm.feature_name"
                                    placeholder="Nama Feature"
                                    outlined
                                />
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item two-line>
                            <v-list-item-content class="pa-0">
                                <v-list-item-title class="font-weight-bold">
                                    Redis Code *
                                </v-list-item-title>
                                <v-text-field
                                    v-model="featureForm.redis_code"
                                    placeholder="Redis Code"
                                    outlined
                                />
                            </v-list-item-content>
                        </v-list-item>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                        <v-btn dark color="blew" @click="addNewFeature()"
                            >Simpan</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import Modal from "@/modules/global/components/plugins/Modal";
import NotificationsTemplateService from "@/modules/notifications_template/services/notifications_template.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "notifications-template-form",

    components: {
        "app-modal": Modal,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            isLoading: false,
            form: {
                id: null,
                title: "",
                body: "",
                service: "",
                feature: "",
                webapp_link: "",
                android_link: "",
                ios_link: "",
                img_url: null,
            },
            featureModal: false,
            featureForm: {
                service_id: "",
                feature_name: "",
                redis_code: "",
            },
            featureList: [],
            serviceList: [],
            imageFile: null,
            url: null,
        };
    },

    methods: {
        async putObject() {
            var file = this.imageFile;
            const context = this;

            if (!context.form.img_url) {
                if (!context.file) {
                    context.$store.commit("showAlert", {
                        message: `File Banner harus diisi!`,
                        type: "error",
                    });
                }
            }

            context.isLoading = true;
            if (this.validateForm()) {
                var file = this.imageFile;
                if (this.form.img_url && !file) {
                    this.url = this.form.img_url;
                    this.save();
                } else {
                    if (!file) return;
                    try {
                        var filename = `${file.name
                            .split(".")
                            .slice(0, -1)
                            .join(".")}_${+new Date()}.${file.name.substring(
                            file.name.lastIndexOf(".") + 1,
                            file.name.length,
                        )}`;
                        let result = await this.$alioss.put(
                            `assets/notification/${filename}`,
                            file,
                        );
                        await this.$alioss.putACL(
                            `assets/notification/${filename}`,
                            "public-read",
                        );
                        context.url = result.url;
                        context.form.img_url = result.url;
                        context.save();
                    } catch (error) {
                        alert("terjadi kesalahan : " + error);
                        context.isLoading = false;
                    }
                }
            } else this.isLoading = false;
        },

        async getFeatureList() {
            const context = this;
            context.isLoading = true;
            await NotificationsTemplateService.getFeatureList(
                function (response) {
                    if (response.success) {
                        context.featureList = response.data;
                        if (context.$route.query.id)
                            context.getTemplateDetail();
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal mengambil data fitur!`,
                            type: "error",
                        });
                    }
                    context.isLoading = false;
                },
            );
        },

        async getTemplateDetail() {
            const context = this;
            context.isLoading = true;
            await NotificationsTemplateService.getTemplateDetail(
                this.$route.query.id,
                function (response) {
                    if (response.success) {
                        context.form = response.data;
                        context.form.feature = context.featureList.find(
                            (s) => s.feature_name == context.form.feature,
                        ).id;
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal mengambil data notifikasi!`,
                            type: "error",
                        });
                    }
                    context.isLoading = false;
                },
            );
        },

        async getServicesList() {
            const context = this;
            context.isLoading = true;
            await NotificationsTemplateService.getServicesList(
                function (response) {
                    if (response.success) {
                        context.serviceList = response.data;
                    } else {
                        context.$store.commit("showAlert", {
                            message: `Gagal mengambil data service!`,
                            type: "error",
                        });
                    }
                    context.isLoading = false;
                },
            );
        },

        async openFormFeature() {
            this.featureModal = true;
            await this.getServicesList();
        },

        onFileChange(e) {
            const file = e.target.files[0];

            if (file.size > 200000) {
                this.$store.commit("showAlert", {
                    message: `File lebih besar dari 200 KB!`,
                    type: "error",
                });
                return;
            }

            this.imageFile = file;
            this.url = URL.createObjectURL(file);
            this.form.img_url = URL.createObjectURL(file);
        },

        validateForm() {
            var err = false;
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

            if (
                this.form.title == "" ||
                this.form.title == " " ||
                !this.form.title
            ) {
                this.$store.commit("showAlert", {
                    message: "Title wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (
                this.form.body == "" ||
                this.form.body == " " ||
                !this.form.body
            ) {
                this.$store.commit("showAlert", {
                    message: "Body wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (!this.form.feature) {
                this.$store.commit("showAlert", {
                    message: "Fitur wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (!this.form.webapp_link) {
                this.$store.commit("showAlert", {
                    message: "Webapp Link wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (!this.form.ios_link) {
                this.$store.commit("showAlert", {
                    message: "iOS Link wajib diisi!",
                    type: "error",
                });
                err = true;
            } else if (!this.form.android_link) {
                this.$store.commit("showAlert", {
                    message: "Android Link wajib diisi!",
                    type: "error",
                });
                err = true;
            }
            return !err;
        },

        validateFeatureForm() {
            var errFeature = false;
            if (this.featureForm.service_id == "") {
                this.$store.commit("showAlert", {
                    message: "Service wajib diisi!",
                    type: "error",
                });
                errFeature = true;
            } else if (this.featureForm.feature_name == "") {
                this.$store.commit("showAlert", {
                    message: "Feature Name wajib diisi!",
                    type: "error",
                });
                errFeature = true;
            } else if (this.featureForm.redis_code == "") {
                this.$store.commit("showAlert", {
                    message: "Redis Code wajib diisi!",
                    type: "error",
                });
                errFeature = true;
            }
            return !errFeature;
        },

        save() {
            var context = this;
            if (this.validateForm()) {
                if (this.$route.query.id) {
                    NotificationsTemplateService.editNotificationTemplate(
                        context.form,
                        function (response) {
                            if (response.success) {
                                if (
                                    response.data.description ==
                                    "Failed to Record Data"
                                ) {
                                    context.$store.commit("showAlert", {
                                        message: `Gagal menyimpan data!`,
                                        type: "error",
                                    });
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil menyimpan data!`,
                                        type: "success",
                                    });
                                }
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal menyimpan!`,
                                    type: "error",
                                });
                            }

                            context.isLoading = false;
                            context.$router.push("/notifications-template");
                        },
                    );
                } else {
                    NotificationsTemplateService.createNotificationTemplate(
                        context.form,
                        function (response) {
                            if (response.success) {
                                if (
                                    response.data.description ==
                                    "Failed to Record Data"
                                ) {
                                    context.$store.commit("showAlert", {
                                        message: `Gagal menyimpan data!`,
                                        type: "error",
                                    });
                                } else {
                                    context.$store.commit("showAlert", {
                                        message: `Berhasil menyimpan data!`,
                                        type: "success",
                                    });
                                }
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Gagal menyimpan!`,
                                    type: "error",
                                });
                            }

                            context.isLoading = false;
                            context.$router.push("/notifications-template");
                        },
                    );
                }
            } else {
                this.isLoading = false;
            }
        },

        addNewFeature() {
            var context = this;
            if (this.validateFeatureForm()) {
                context.isLoading = true;
                NotificationsTemplateService.createFeature(
                    context.featureForm,
                    function (response) {
                        if (response.success) {
                            if (
                                response.data.description ==
                                "Failed to Record Data"
                            ) {
                                context.$store.commit("showAlert", {
                                    message: `Gagal menyimpan data!`,
                                    type: "error",
                                });
                            } else {
                                context.$store.commit("showAlert", {
                                    message: `Berhasil menyimpan data!`,
                                    type: "success",
                                });
                            }
                        } else {
                            context.$store.commit("showAlert", {
                                message: `Gagal menyimpan!`,
                                type: "error",
                            });
                        }
                        context.featureModal = false;
                        context.isLoading = false;
                        context.getFeatureList();
                    },
                );
            }
        },
    },

    mounted: function () {
        this.getFeatureList();
    },
};
</script>



// WEBPACK FOOTER //
// NotificationsTemplateForm.vue?481e42f8